<template>
  <a-card :title="chartTitle" size="small" class="chart-card" :loading="loading">
    <highcharts :options="chartOptions" />
  </a-card>
</template>

<script>
import { Chart } from 'highcharts-vue';
import { convertTimeArray, getUnitLabel } from 'src/utils/timeConversion';

export default {
  name: 'StandardDeviationChart',
  components: {
    highcharts: Chart,
  },
  props: {
    stdDeviationData: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    timeUnit: {
      type: String,
      default: 'seconds',
      validator: (value) => ['seconds', 'minutes'].includes(value),
    },
  },
  computed: {
    chartData() {
      return Object.keys(this.stdDeviationData).length > 0
        ? this.stdDeviationData
        : {
            labels: [],
            std_deviation_cycle_time: [],
          };
    },
    unitLabel() {
      return getUnitLabel(this.timeUnit);
    },
    unitLabelAbbr() {
      return getUnitLabel(this.timeUnit, true);
    },
    chartTitle() {
      return `Standard Deviation of Cycle Time (${this.unitLabel})`;
    },
    chartOptions() {
      const convertedData = convertTimeArray(
        this.chartData.std_deviation_cycle_time,
        this.timeUnit
      );
      return {
        chart: {
          type: 'column',
          height: 400,
          backgroundColor: 'transparent',
          zoomType: 'xy',
        },
        title: {
          text: null,
        },
        xAxis: {
          categories: this.chartData.labels,
          labels: {
            style: {
              fontSize: '11px',
            },
          },
        },
        yAxis: {
          title: {
            text: `Standard Deviation (${this.unitLabel})`,
          },
          labels: {
            format: `{value}${this.unitLabelAbbr}`,
          },
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          column: {
            colorByPoint: true,
            dataLabels: {
              enabled: true,
              format: `{y:.2f}${this.unitLabelAbbr}`,
              style: {
                fontSize: '10px',
              },
            },
          },
        },
        colors: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4'],
        series: [
          {
            name: 'Standard Deviation',
            data: convertedData,
          },
        ],
        credits: {
          enabled: false,
        },
        tooltip: {
          pointFormat: `<b>{point.y:.2f}</b> ${this.unitLabel}`,
        },
      };
    },
  },
};
</script>

<style scoped>
.chart-card {
  height: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  transition: box-shadow 0.3s ease;
}

.chart-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>
